const ANIMATION_AT_LANDING_360 = {
    name: '360',
    azimuthAngle: 360,
    time: 3 * 1000,
};
const ANIMATION_AT_LANDING_360_WITH_ZOOM = {
    name: '360-with-zoom',
    azimuthAngle: 360,
    time: 3 * 1000,
    withZoom: true,
};
const ANIMATION_AT_LANDING_90_WITH_ZOOM = {
    name: '90-with-zoom',
    azimuthAngle: 90,
    initialPosition: {
        theta: -45,
    },
    time: 3 * 1000,
    withZoom: true,
};
const ANIMATION_AT_LANDING_TOP_LEFT = {
    name: 'top-left',
    azimuthAngle: 30,
    initialPosition: {
        theta: 0,
    },
    polarAngle: 20,
    time: 1 * 1000,
};
export const ANIMATIONS_AT_LANDING = [
    ANIMATION_AT_LANDING_360,
    ANIMATION_AT_LANDING_360_WITH_ZOOM,
    ANIMATION_AT_LANDING_90_WITH_ZOOM,
    ANIMATION_AT_LANDING_TOP_LEFT,
];
export const ANIMATIONS_AT_LANDING_VALUES = [
    ANIMATION_AT_LANDING_360.name,
    ANIMATION_AT_LANDING_360_WITH_ZOOM.name,
    ANIMATION_AT_LANDING_90_WITH_ZOOM.name,
    ANIMATION_AT_LANDING_TOP_LEFT.name,
];
